import { Dialog, Transition } from '@headlessui/react'
import React, { FC, Fragment } from 'react'
import ChatAgent from '../../../pages/chat-agent';
import FloatingChatHeader from './FloatingChatHeader';
import { useAppSelector } from '../../../app/hooks';
interface IFloatingChatProps {
    isOpen: boolean
    closeModal: () => void
}



const FloatingChat: FC<IFloatingChatProps> = ({ isOpen, closeModal  }) => {
    const { opponentFloating } = useAppSelector((state) => state.chatagent);

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[30]" onClose={() => { }}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/10" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="fixed bottom-1 top-1 right-0 w-full max-w-md transform overflow-hidden rounded-lg bg-gray-100 text-left align-middle shadow-xl transition-all">
                                <FloatingChatHeader
                                    name={opponentFloating.fullName}
                                    status={opponentFloating.status}
                                    closeModal={closeModal}
                                />
                                <div className="h-fit">
                                    <ChatAgent layoutType="FLOATING_PANEL" />
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default FloatingChat